import { Button } from '@rio-cloud/rio-uikit';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { NameInputChange } from '../../../screens/Expenses';
import { useState } from 'react';
import InputSelect from '../Receipt/select';


interface Props {
    show: boolean;
    onClose: () => void;
    onSave: (value: string, selectValue?: string) => void;
    title: string;
    placeholder: string;
    name?: string;
}

const categoryOptions = [
    { id: 'DIRETO', label: 'Despesas Diretas' },
    { id: 'OPERACIONAL', label: 'Despesas Operacionais' },
];


const DialogCreateCategory = ({ show, onClose, onSave, title, placeholder, name }: Props) => {
    const [error, setError] = useState('');
    const [errorSelect, setErrorSelect] = useState('');

    const [valueCategory, setValueCategory] = useState('');
    const [selectCategory, setSelectCategory] = useState('');

    const handleSubmit = () => {
        if(!valueCategory || !selectCategory) {
            if (!valueCategory) {
                setError('Campo obrigatório')
            } 
            if (!selectCategory) {
                setErrorSelect('Campo obrigatório')
            }
            return 
        }
        
        setError('');
        setErrorSelect('');
        
        setValueCategory('')
        setSelectCategory('')

        onSave(valueCategory, selectCategory);
    }

    const handleClose = () => {
        onClose();
        setValueCategory('')
        setSelectCategory('')
    }

     const inputChange = (name: NameInputChange, value?: string) => {
        setSelectCategory(value || '');
     }

    const contentTooltip = () => {
        return (
            <div className='display-flex flex-column align-items-start gap-5 padding-5'>
                <p className='margin-0'><span className='text-bold'>Despesas diretas:</span> Custos ligados à viagem e ao uso do veículo.</p>
                <p className='margin-0'><span className='text-bold'>Despesas operacionais:</span> Custos para manter a empresa funcionando, fora da viagem.</p>
            </div>
        )
    }

    return (
        <Dialog
            show={show}
            title={<span className='text-medium text-size-16'>{title}</span>}
            body={
                <>
                    <div className={`form-group ${error ? "has-feedback has-error" : ""}`}>
                        <label htmlFor="inputValue">
                            <span>{placeholder}</span>
                        </label>
                        <div className="input-group">
                            <input id="inputValue" type="text" className="form-control" value={valueCategory} onChange={(e) => setValueCategory(e.target.value)} name="value" />
                        </div>
                        {error ? (
                            <span className="form-control-feedback rioglyph rioglyph-error-sign">
                            </span>
                        ) : null}
                        <span className="help-block">
                            <span>{error}</span>
                        </span>
                    </div>
                    <div className={`form-group ${errorSelect ? "has-feedback has-error" : ""}`}>
                        <InputSelect
                            inputChange={inputChange}
                            label='Qual o tipo de despesa?'
                            name='category'
                            onCreateNewOption={() => {}}
                            options={categoryOptions}
                            value={selectCategory}
                            errorMessage={errorSelect}
                            tooltip={contentTooltip()}
                        />
                    </div>
                </>
            }
            onClose={handleClose}
            footer={
                <div className='display-flex align-items-center justify-content-end gap-10'>
                    <Button onClick={handleClose} className='width-150 rounded-small'>Cancelar</Button>
                    <Button onClick={handleSubmit} bsStyle={Button.PRIMARY} className='width-150 rounded-small'>Salvar</Button>
                </div>
            }
            showCloseButton
            useOverflow
        />
    )
}

export default DialogCreateCategory;